import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { SummaryContent } from "@/types/report";

interface Props {
  content: SummaryContent;
}

export function SummarySection({ content }: Props) {
  return (
    <div className="report-summary">
      <Markdown remarkPlugins={[remarkGfm]}>{content.text}</Markdown>
    </div>
  );
}
